import { Loader2 } from 'lucide-react'
import { useState } from 'react'

import { Button } from '@/components/ui/button'
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { useAuth } from '@/lib/auth'
import { useI18n } from '@/lib/i18n'

export function ResetPasswordPage() {
  const [newPassword, setNewPassword] = useState('')
  const { isLoading, resetPassword } = useAuth()
  const { t } = useI18n()

  const handleSubmit = async () => {
    if (!newPassword)
      return
    if (resetPassword) {
      await resetPassword({ newPassword })
    }
  }

  return (
    <div className="h-screen pt-16">
      <div className="mx-auto w-full max-w-sm pt-24 md:max-w-md">
        <Card>
          <CardHeader>
            <CardTitle className="text-lg md:text-xl">
              {t('auth.resetPassword.title')}
            </CardTitle>
            <CardDescription className="text-xs md:text-sm">
              {t('auth.resetPassword.description')}
            </CardDescription>
          </CardHeader>
          <CardContent>
            <div className="grid gap-4">
              <div className="grid gap-2">
                <Label htmlFor="password">{t('auth.resetPassword.password')}</Label>
                <Input
                  id="password"
                  type="password"
                  placeholder={t('auth.resetPassword.passwordPlaceholder')}
                  required
                  onChange={(e) => {
                    setNewPassword(e.target.value)
                  }}
                  value={newPassword}
                />
              </div>
              <Button
                type="submit"
                className="w-full"
                disabled={isLoading}
                onClick={handleSubmit}
              >
                {isLoading ? (
                  <Loader2 size={16} className="animate-spin" />
                ) : (
                  t('auth.resetPassword.button')
                )}
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  )
}
